import React from "react";
import { Box, Typography } from "@mui/material";
import { IconArrowNarrowRight } from "@tabler/icons";
import { styled } from "@mui/material/styles";

export const StyledIconArrowNarrowRight = styled(IconArrowNarrowRight)(
  ({ theme }) => ({
    color: theme.palette.grey.main,
  })
);

export default function RegisterTextRow({ value }) {
  return (
    <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
      <StyledIconArrowNarrowRight />
      <Typography ms={2} fontSize={14} fontWeight={600} color="grey.main">
        {value}
      </Typography>
    </Box>
  );
}
